/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Load_MoreInputs */

const cs_public_site_load_more = /** @type {(inputs: Public_Site_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit další`)
};

const en_public_site_load_more = /** @type {(inputs: Public_Site_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load more`)
};

/**
* | output |
* | --- |
* | "Load more" |
*
* @param {Public_Site_Load_MoreInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_load_more = /** @type {((inputs?: Public_Site_Load_MoreInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Load_MoreInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_load_more(inputs)
	return cs_public_site_load_more(inputs)
});